import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function FaQReducer(state = InitialState.frequentlyAskedQuestions, action) {
  switch (action.type) {
    case types.LOAD_FAQS_SUCCESS:
      return action.questions;
    case types.SAVE_NEW_FAQ_SUCCESS:
      return state.map(i => i).concat([action.question]);
    case types.UPDATE_FAQ_SUCCESS:
      return state.map(i => (i.questionId === action.question.questionId ? action.question : i));
    case types.REMOVE_FAQ_SUCCESS:
      return action.wasRemoved
        ? state.filter(i => i.questionId !== action.questionId)
        : state.map(i => i);
    case types.UPDATE_USEFULNESS_SCORE_SUCCESS:
      return state.map(i => (i.questionId === action.question.questionId ? action.question : i));
    default:
      return state;
  }
}
